import { GET_ALL_CUSTOMERS_SUCCESS, GET_ALL_CUSTOMERS_FAIL, LOGOUT, GET_ALL_CUSTOMERS_REQUEST } from "../actions/types";

const initialState = { customers: null, loading: false, error: null };

export const getAllCustomersReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_CUSTOMERS_REQUEST:
      return {
        ...state,

        customers: null,
        loading: true,
      };
    case GET_ALL_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: payload,
        loading: false,
      };
    case GET_ALL_CUSTOMERS_FAIL:
      return {
        ...state,
        customers: [],
        error: payload,
        loading: false,
      };
    // case LOGOUT:
    //   return {
    //     ...state,
    //     customers: false,
    //     user: null,
    //   };
    default:
      return state;
  }
};
